/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._flex_i3x4e_157 {
  display: flex;
}

._justify-content-space-between_i3x4e_161 {
  justify-content: space-between;
}

._tabular-nums_i3x4e_165 {
  font-variant-numeric: tabular-nums;
}

@keyframes _show_i3x4e_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Text styles */
._EmptyNotice_i3x4e_178 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.214;
  color: #1a1818;
}

._EmptyNotice_i3x4e_178 {
  display: block;
  width: 100%;
  padding: 0.625rem;
  border-radius: 0.25rem;
  background-color: #e9e8ea;
  color: #8f8d91;
  text-align: center;
}